import { useEffect, useRef } from 'react';

import { useAppContext } from '../../../Services/AppContext';

export default function useSocket(key: string, run: (data?: any) => void) {
	const { socket } = useAppContext();
	const runRef = useRef(run);
	runRef.current = run;
	useEffect(() => {
		if (!socket) return;
		const handler = (data?: any) => {
			runRef.current(data);
		};
		socket.on(key, handler);
		return () => {
			socket.off(key, handler);
		};
	}, [socket, key]);
}
